@if (isLeveransvirke$ | async) {
  <rask-toggle-panel label="Förkalkyl" [defaultExpanded]="false">
    <rask-tabs class="child" layout="child" [wrap]="true" [useRoute]="false">
      <rask-tab label="Virkeskostnad">
        <rask-atgard-virkeskostnad></rask-atgard-virkeskostnad>
      </rask-tab>
      <rask-tab label="Nettoberäkning">
        <rask-forkalkyl-nettoberakning></rask-forkalkyl-nettoberakning>
      </rask-tab>
    </rask-tabs>
  </rask-toggle-panel>
}